export const LogoutSystem = ()=> {
    localStorage.removeItem(process.env.REACT_APP_TOKEN!);
    localStorage.removeItem(process.env.REACT_APP_TOKEN_OPTIONS!);
    localStorage.removeItem(process.env.REACT_APP_TOKEN_ROUTER!);
    window.location.replace('');
    // const request = indexedDB.deleteDatabase('keyval-store');
}